export const ROUTES = {
    account: "account",
    preview: "preview",
};
